import React from "react";

import { Helmet } from "react-helmet";

import { Coupons } from "features/Coupons";
import { PageTitle } from "shared/ui";

const TITLE = "Скидки и промокоды";

// Тонкая обёртка над фичей: ставит chrome страницы и отдаёт всё остальное features/Coupons.
const CouponsListPage = () => {
    return (
        <>
            <PageTitle>{TITLE}</PageTitle>
            <Helmet title={TITLE} />
            <Coupons />
        </>
    );
};

export default CouponsListPage;
